// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__eEjoJ","choiceBoxes":"toolbarselects_choiceBoxes__ACDT6","simpleField":"toolbarselects_simpleField__3nxiN"};